const messages = {
    pt: {
        translations: {
            select: {
                indicator: 'Selecione ou busque o indicador',
                goal: 'Selecione ou busque a meta',
                tag: 'Selecione ou crie uma nova tag',
                user: 'Selecione ou busque o usuário',
                graphic: 'Selecione o(s) tipo(s) de gráfico',
                notfound: 'Nenhum registro encontrado',
                minletters: 'Digite ao menos 3 letras para pesquisar',
                loading: 'Aguarde...'
            },
            boxes: {
                textTotal: 'Total indicadores',
                textEdit: 'Edição',
                textApr: 'Aprovação',
                textPub: 'Publicados',
                textTimeHeader: 'Tempo médio',
                textTimeFooter: 'por indicador',
                textTime: 'horas'
            },
            header: {
                all: 'Todos os indicadores',
                allGoal: 'Todas as metas',
                draft: 'Respondente',
                draft_pt: 'Rascunho PT',
                approved_pt: 'Aguardando aprovação PT',
                approved_en: 'Aguardando aprovação EN',
                approved: 'Aguardando aprovação',
                published: 'Publicados',
                comments: 'Comentários',
                delete: 'Ocultados',
                approval_esg: 'Aprovação - Líder ESG',
                evaluation_avesso: 'Avaliação - Avesso',
                evaluation_suzano: 'Avaliação - Suzano',
                evaluation_suzano_en: 'Avaliação - Suzano - EN',
                evaluation_avesso_suzano: 'Avaliação - Avesso/Suzano',
                finished: 'Finalizado',
                finished_pt: 'Finalizado - PT',
                finished_en: 'Finalizado - EN',
                translate: 'Tradutor',
                draft_en: 'Rascunho - EN',

            },
            titlePage: {
                dashboard: 'Painel',
                upload: 'Envio de arquivos',
                workflow: 'Fluxo de trabalho',
                logs: 'Logs',
                users: 'Usuários',
                addUsers: 'Adicionar usuário',
                settings: 'Configurações do indicador',
                notifications: 'Notificações',
                profile: 'Perfil',
                indicators: 'Indicadores',
                indicator: 'Indicador',
                documents: 'Documentos',
                tablesAndCharts: 'Tabelas e gráficos',
                goals: 'Metas',
                content: 'Conteúdo'
            },
            buttons: {
                profile: 'Perfil',
                logout: 'Sair',
                save: 'Salvar',
                add: 'Adicionar',
                login: 'Acessar',
                recoverPass: 'Recuperar senha',
                comment: 'Comentar',
                cancel: 'Cancelar',
                delete: 'Excluir',
                deleteAll: 'Excluir todos',
                migrate: 'Migrar',
                occult: 'Ocultar',
                restore: 'Restaurar',
                confirm: 'Confirmar',
                saveImage: 'Salvar imagem',
                close: 'Fechar',
                changeAvatar: 'Alterar imagem',
                addLineStart: ' Linha ao inicio',
                addLineEnd: ' Linha ao fim',
                addStart: ' Antes',
                addEnd: ' Depois',
                addHeader: ' Cabeçalho',
                insertLine: 'Inserir Linha',
                insertColumn: 'Inserir Coluna',
                edit: 'Editar',
                more: 'Ver mais',
                search: 'Pesquisar',
                return: 'Voltar'
            },
            upload: {
                headerTable: 'Histórico',
                messageBox: 'Clique ou arraste o(s) arquivo(s) para esta área para fazer o envio',
                messageError: 'Arquivo não suportado',
                messageDrop: 'Solte os arquivos aqui',
                tableRecords: 'Nenhum registro encontrado'
            },
            stage: {
                title: 'Título',
                context: 'Contexto',
                certificates: 'Certificados',
                tags: 'Tags',
                table: 'Tabela',
                footer: 'Notas de rodapé',
                complements: 'Informações complementares',
            },
            logs: {
                headerTable: 'Logs do usuário'
            },
            table: {
                noData: 'Nenhum registro encontado',
                showing: 'Mostrando do ',
                to: ' ao ',
                of: ' de ',
                records: ' registros',
                previous: 'Anterior',
                next: 'Próximo',
                change: 'Mudar visualizacão:'
            },
            user: {
                name: 'Nome de usuário',
                profile: 'Perfil',
                status: 'Status ',
                permissions: 'Permissões',
                admin: 'Administador',
                addComments: 'Incluir comentários, moderação do indicador',
                alterStage: 'Alterar o estágio do indicador',
                logUser: 'Verificar o log de usuários',
                uploadIndicators: 'Fazer o upload de indicadores',
                editIndicator: 'Editar indicador',
                editGoal: 'Editar meta',
                password: 'Senha',
                active: 'Ativo'
            },
            messages: {
                newMessages: 'Não há novas mensagens',
                seeAll: 'Ver todas',
                messages: 'Mensagens',
                complement: ' comentou sobre o indicador ',
                complementGoal: ' comentou sobre a meta '
            },
            filelist: {
                total: 'Total de indicadores'
            },
            questions: {
                deleteComment: 'Deseja excluir este comentário?',
                editUser: 'Deseja alterar as informações deste usuário?',
                deleteUser: 'Deseja excluir este usuário?',
                deleteTag: 'Deseja excluir esta tag?',
                occultIndicator: 'Deseja ocultar o indicador ',
                deleteIndicator: 'Deseja excluir permanentemente o indicador ',
                restoreIndicator: 'Deseja restaurar o indicador ',
                editIndicator: 'Deseja editar o indicador ',
                deleteArchive: 'Deseja excluir o arquivo ',
                editData: 'Deseja editar os dados?',
                editChart: 'Deseja editar este gráfico?',
                deleteChart: 'Deseja excluir este gráfico',
                occultGoal: 'Deseja ocultar a meta ',
                deleteGoal: 'Deseja excluir permanentemente a meta ',
                restoreGoal: 'Deseja restaurar a meta ',
                editGoal: 'Deseja editar a meta ',
            },
            success: {
                deleteComment: 'Comentário excluído com sucesso!',
                deletedTag: 'Tag excluída com sucesso!',
                createUser: 'Usuário criado com sucesso!',
                editUser: 'Usuário alterado com sucesso!',
                deleteUser: 'Usuário excluído com sucesso!',
                successOccult: 'Indicador ocultado com sucesso!',
                successRestore: 'Indicador restaurado com sucesso!',
                editSuccessIndicator: 'Indicador editado com sucesso!',
                saveTag: 'Tag alterada com sucesso!',
                createTag: 'Tag criada com sucesso!',
                editTag: 'Tag alterada com sucesso!',
                deleteSuccess: 'Arquivo excluido com sucesso!',
                editData: 'Dados alterados com sucesso!',
                newChart: 'Gráfico criado com sucesso!',
                editChart: 'Gráfico alterado com sucesso!',
                deleteChart: 'Gráfico excluído com sucesso!',
                editSuccessGoal: 'Meta editado com sucesso!',
                successOccultGoal: 'Meta ocultada com sucesso!',
                successRestoreGoal: 'Meta restaurada com sucesso!',
                createContent: 'Conteúdo criado com sucesso!',
                editContent: 'Conteúdo editado com sucesso!'
            },
            error: {
                error404: 'Página não encontrada',
                error401: 'Acesso não autorizado',
                badRequest: 'Falha na requisição!',
                notFoundIndicator: 'Indicador não encontrado!',
            },
            warning: {
                differentStatus: 'Selecione um estágio diferente do anterior!',
                errorTag: 'Já existe uma tag com este nome!',
            },
            inputError: {
                password: 'Preencha a senha',
                userName: 'Preencha o nome de usuário',
                emailInvalid: 'E-mail inválido',
                requiredEmail: 'Preencha o E-mail',
                tag: 'Selecione a tag',
                title: 'Preencha o título'
            },
            formModal: {
                indicator: 'Indicador ',
                goal: 'Meta',
                migrate: ' migrado do estágio ',
                to: ' para ',
                questionMigrate1: 'Voce tem certeza que deseja migrar o indicador ',
                questionMigrate1Goal: 'Voce tem certeza que deseja migrar a meta ',
                questionMigrate2: ' em ',
                questionMigrate3: ' para outro estágio do fluxo?'
            },
            label: {
                changeAvatar: 'Alterar foto do perfil',
                choseLanguage: 'Escolha o idioma',
                title: 'Título',
                description: 'Descrição',
                archive: 'Arquivo',
                archives: 'Arquivos',
                user: 'Usuário',
                createdAt: 'Data de cadastro',
                messagesUsers: 'Mensagens de usuários',
                restoreIndicator: 'Restaurar indicador',
                editIndicator: 'Editar indicador',
                advanceStage: 'Avançar estágio',
                occultIndicator: 'Ocultar indicador',
                copyLink: 'Copiar link',
                deleteArchive: 'Excluir arquivo',
                downloadArchive: 'Baixar arquivo',
                search: 'Procurar',
                cleanFilter: 'Limpar filtro',
                selectLine: 'Selecione a linha',
                select: 'Selecione',
                selectColumn: 'Selecione a coluna',
                column: 'Coluna',
                columns: 'Colunas',
                language: 'Idioma',
                metaTitle: 'Título da meta',
                metaSubtitle: 'Subtítulo da meta',
                scope: 'Escopo',
                ambition: 'Ambição',
                unit: 'Unidade',
                units: 'Unidades',
                unitConvert: 'Unidade de conversão',
                newTable: 'Nova tabela',
                sendFiles: 'Enviar arquivos',
                editGoal: 'Editar meta',
                restoreGoal: 'Restaurar meta',
                occultGoal: 'Ocultar meta',
                deletePermanent: 'Excluir permanentemente',
                results2021: 'Resultados 2021',
                whatWeWillDo2022: 'O que faremos 2022',
                cancelArchive: 'Cancelar envio',
                group: 'Grupo',
                varid: 'Variedade',
                updateData: 'Atualizar dados',
                ourProgress: 'Nosso progresso',
                category: 'Categoria'
            },
            placeholder: {
                searchDocuments: 'Buscar por nome do arquivo ou título',
                filterTag: 'Filtrar tags'
            },
            tags: {
                materialThemes: 'Material themes',
            },
            chart: {
                graphic: 'Gráfico',
                graphics: 'Gráficos',
                series: 'Series',
                axes: 'Eixos',
                title: 'Título',
                legend: 'Legenda',
                subTitle: 'Sub título',
                text: 'Texto',
                color: 'Cor',
                textColor: 'Cor do texto',
                background: 'Fundo do box',
                showTitle: 'Mostrar título',
                alignX: 'Alinhamento X',
                alignY: 'Alinhamento Y',
                alignTitle: 'Alinhamento do título',
                alignSubTitle: 'Alinhamento do sub título',
                center: 'Centro',
                left: 'Esquerda',
                right: 'Direita',
                top: 'Topo',
                middle: 'Meio',
                bottom: 'Fim',
                showLegend: 'Mostrar legenda',
                showLabel: 'Mostrar rótulos',
                layout: 'Posição',
                horizontal: 'Horizontal',
                vertical: 'Vertical',
                height: 'Altura',
                export: 'Exportar',
                filename: 'Nome do arquivo',
                gridLineWidthX: 'Tamanho da linha X',
                gridLineWidthY: 'Tamanho da linha Y',
                gridTypeX: 'Estilo da linha X',
                gridTypeY: 'Estilo da linha Y',
                labelX: 'Texto horizontal',
                labelY: 'Texto vertical',
                minY: 'Valor mín. Y',
                maxY: 'Valor max. Y',
                invertAxes: 'Inverter eixos',
                radius: 'Arredondar bordas',
                print: 'Imprimir gráfico',
                borderWidth: 'Borda do box',
                bgChart: 'Fundo do gráfico',
                borderColor: 'Cor da borda',
                borderWidthChart: 'Borda do gráfico',
                borderLegend: 'Borda da legenda',
                dataLabel: 'Rótido de dados',
                optionsDash: {
                    Solid: 'Sólido',
                    ShortDash: 'Traço Curto',
                    ShortDot: 'Ponto Curto',
                    ShortDashDot: 'Ponto de traço curto',
                    ShortDashDotDot: 'Traço Curto Ponto Ponto',
                    Dot: 'Ponto',
                    Dash: 'Traço',
                    LongDash: 'Traço Longo',
                    DashDot: 'Ponto de traço',
                    LongDashDot: 'Traço Longo',
                    LongDashDotDot: 'Traço Longo Ponto Ponto',
                },
                gridColorX: 'Cor da linha X',
                gridColorY: 'Cor da linha Y',
                baseColor: 'Cor da linha base',
                titleColor: 'Cor do título',
                subtitleColor: 'Cor do subtítulo',
                titleLegendColor: 'Cor do titulo da legenda',
                legendColor: 'Cor da legenda',
                xColor: 'Cor do título eixo X',
                yColor: 'Cor do título eixo Y',
                labelXColor: 'Cor do texto eixo X',
                labelYColor: 'Cor do texto eixo Y',
                plotColor: 'Cor do texto',
                selected:  'Selecionados'
            },
            category: {
                AnnualReports: 'Relatórios Anuais',
                Policies: 'Políticas',
                Positioning: 'Posicionamentos',
                CodeOfConduct: 'Código de Conduta',
                SustainableFinance: 'Finanças Sustentáveis',
                IndicatorsBook: 'Cadernos de Indicadores',
                AdditionalInformation: 'Outras informações'
            },
            units: {
                texto: 'texto',
                megalitros: 'ML',
                metros_cubicos: 'm³',
                tonelada_de_CO2_equivalente: 'tCO2e',
                dolares: 'US$',
                reais: 'R$',
                horas: 'horas',
                taxa: 'taxa',
                numero_total: 'número total',
                porcentagem: '%',
                hectares: 'ha',
                quilometros_quadrados: 'km²',
                gigajoules: 'GJ',
                megawatt_hora: 'MWh',
                toneladas: 't',
                mg_L: 'mg/L',
                kg_t: 'kg/t',
                m3_ton: 'm³/ton',
                quilograma: 'kg',
                media: 'média',
            }
        }
    }
}


export { messages }
